export enum PROVIDER_STATUS_ENUM {
  ACTIVE = 'Activo',
  LOCKED = 'Bloqueado',
  DELETED = 'Eliminado'
}

export enum PROVIDER_STATUS_COLOR_ENUM {
  ACTIVE = 'primary',
  LOCKED = 'warning',
  DELETED = 'danger'
}
